import {Alert, TextRegular, TextSemiBold} from '@hm/fundamental'
import React from 'react'
import {useFormContext} from 'react-hook-form'

import {GroupedRoleAssignment} from '../../modules/ManageUsers.selectors'

export const FormErrors = () => {
  const {formState} = useFormContext<GroupedRoleAssignment>()

  const rootError = formState.errors.root

  if (!rootError) {
    return null
  }

  if (rootError.type === 'server' && typeof rootError.message === 'object') {
    const errorData = rootError.message as any
    if (errorData.response?.data) {
      return (
        <Alert variant="error" data-cy="role-form-error">
          <div className="flex flex-col">
            <TextSemiBold>{errorData.response.data.title}</TextSemiBold>
            <TextRegular>{errorData.response.data.message}</TextRegular>
          </div>
        </Alert>
      )
    }
  }

  return (
    <Alert variant="error" data-cy="role-form-error">
      <TextRegular>{rootError.message}</TextRegular>
    </Alert>
  )
}
